import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PencilSimple } from '@phosphor-icons/react';
import { Button } from '@/components/ui-kit/button';
import {
  Employee,
  EmployeeProfileSkeleton,
  EmployeeProfileView,
  EmployeesPagingResult,
  useGetMyEmployee,
} from '@/modules/hr-directory';

/** "HR Info": the signed-in person's own employee record (shared with the directory's details page). */
export const HrInfo = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useGetMyEmployee();
  const employee: Employee | undefined = (data as { Employees?: EmployeesPagingResult })?.Employees
    ?.items?.[0];

  if (isLoading) {
    return <EmployeeProfileSkeleton />;
  }

  if (!employee) {
    return <p className="text-sm text-muted-foreground">{t('NO_HR_RECORD_FOUND')}</p>;
  }

  return (
    <EmployeeProfileView
      employee={employee}
      isSelf
      actions={
        // A pencil icon in the card's corner on a phone.
        <Button
          variant="outline"
          aria-label={t('EDIT_PROFILE')}
          title={t('EDIT_PROFILE')}
          className="max-sm:size-9 max-sm:p-0"
          onClick={() => navigate('/profile/edit')}
        >
          <PencilSimple className="size-4" />
          <span className="max-sm:sr-only">{t('EDIT_PROFILE')}</span>
        </Button>
      }
    />
  );
};
